import { DirectiveOptions, VNode } from 'vue';

const directive: DirectiveOptions = {
    inserted(el: HTMLElement, binding: any, vnode: VNode) {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const firstLink = el.querySelector('a');

            if (firstLink) {
                const href = firstLink.getAttribute('href');

                if (href) {
                    window.location.href = href;
                }
            }
        });
    }
}

export default directive;